import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SFIconButton from "../button/iconButton";
import { SFLanguageIcon } from "../icons";
import SFDropdown from "../dropdown";

import flags from "./flags";

const SFLanguagePicker = (props) => {
  const { i18n, t } = useTranslation();

  const [dropDownState, setDropDownState] = useState({
    open: false,
    anchorEl: null,
  });

  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "languageChange" &&
          event.data?.language &&
          event.data.language !== i18n.language) {
        i18n.changeLanguage(event.data.language);
        localStorage.setItem("selectedLanguage", event.data.language);
      }
    };

    const handleLanguageChanged = (lng) => {
      setLanguage(lng);
    };

    window.addEventListener("message", handleMessage);
    i18n.on("languageChanged", handleLanguageChanged);

    return () => {
      window.removeEventListener("message", handleMessage);
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, [i18n]);

  const languageToggleHandler = (language) => {
    i18n.changeLanguage(language.lang_code, () => {
      localStorage.setItem("selectedLanguage", language.lang_code);
    });
    setLanguage(language.lang_code);
    handleDialogClose();
  };

  const handleDialogClose = () => {
    setDropDownState((prevState) => ({ ...prevState, open: false }));
  };

  const toggleHandler = (e) => {
    e.stopPropagation();
    setDropDownState((prevState) => ({
      ...prevState,
      open: !prevState.open,
      anchorEl: e.currentTarget,
    }));
  };

  return (
    <>
      <SFDropdown
        open={dropDownState.open}
        anchorEl={dropDownState.anchorEl}
        onClose={handleDialogClose}
        minWidth={120}
        trigger={
          <SFIconButton onClick={toggleHandler} color="black"
            ariaLabel={t(
              "components.header.languageDropdownAriaLabel"
            )}>
            <SFLanguageIcon />
          </SFIconButton>
        }
        val
        items={props.languages.map((lang) => ({
          icon: <img src={flags[lang.lang_code]} style={{ marginRight: 10 }} />,
          label: lang.language || lang,
          onClick: languageToggleHandler.bind(this, lang),
          selected: language === lang.lang_code,
        }))}
      />
    </>
  );
};

SFLanguagePicker.propTypes = {
  languages: PropTypes.array,
  selectedLanguage: PropTypes.string,
};

export default SFLanguagePicker;
